import { render, staticRenderFns } from "./collect_sub.vue?vue&type=template&id=27359f1e&scoped=true&"
import script from "./collect_sub.vue?vue&type=script&lang=js&"
export * from "./collect_sub.vue?vue&type=script&lang=js&"
import style0 from "./collect_sub.vue?vue&type=style&index=0&id=27359f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27359f1e",
  null
  
)

export default component.exports